import {
  GET_LIVE_SCORES_EVENTS_REQUEST,
  GET_LIVE_SCORES_EVENTS_SUCCESS,
  GET_LIVE_SCORES_EVENTS_FAILURE,
  SUBSCRIBE_EVENT_SUCCESS,
  DELETE_SUBSCRIBE_EVENT_SUCCESS,
  GET_LIVE_SCORES_EVENTS_UPDATE_FILTER,
  LIVE_SCORES_ACTIVE_TYPE
} from 'Store/constants';
import { applyLiveScoresHeaderFilter } from 'Utils/liveScoreHeaderFilterHelper';

const initialState = {
  competitions: [],
  basketballEvents: [],
  soccerEvents: [],
  filters: [],
  mobileLiveScoreCouponEvents: [],
  mobileLiveScoreFollowings: [],
  activeType: '',
  isLoading: false,
  error: null,
  isFetched: false
};

function subscribeStateConstructor (data, eventId, following) {
  return {
    ...data,
    events: data.events = data.events.map(event => (
      event.eventId === eventId ? { ...event, following: following } : event
    ))
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIVE_SCORES_EVENTS_REQUEST:
      return { ...state, isLoading: true, isFetched: false, error: null };
    case GET_LIVE_SCORES_EVENTS_SUCCESS: {
      let newState;
      const filter = action.payload.filters[0];
      if (!filter) {
        return { ...state, ...action.payload, isLoading: false, isFetched: true, error: null };
      }
      const eventType = action.payload.eventType[0];
      const filteredEventList = applyLiveScoresHeaderFilter(action.payload.competitions, filter);
     

      newState = {
        ...state,
        soccerEvents: eventType === 'soccer' ? filteredEventList : null,
        basketballEvents: eventType === 'basketball' ? filteredEventList : null,
        mobileLiveScoreCouponEvents: eventType === 'coupon' ? filteredEventList : null,
        competitions: action.payload.competitions,
        isLoading: false,
        isFetched: true,
        error: null
      };

      return newState;
    }

    case GET_LIVE_SCORES_EVENTS_FAILURE:
      return { ...state, isLoading: false, isFetched: false, error: action.payload };
      

    case GET_LIVE_SCORES_EVENTS_UPDATE_FILTER: {
      let newState;
      const filter = action.payload.filters[0];
      if (!filter) {
        return { ...state, ...action.payload, isLoading: false, isFetched: true, error: null };
      }
      const eventType = action.payload.eventType[0];
      const filteredEventList = applyLiveScoresHeaderFilter(action.payload.competitions, filter);
      

      newState = {
        ...state,
        soccerEvents: eventType === 'soccer' ? filteredEventList : null,
        basketballEvents: eventType === 'basketball' ? filteredEventList : null,
        mobileLiveScoreCouponEvents: eventType === 'coupon' ? filteredEventList : null,
        isLoading: false,
        isFetched: true,
        error: null
      };
  
      return newState;
    }
    case SUBSCRIBE_EVENT_SUCCESS: {
      let newState;
      if (action.payload.sportType === 'SOCCER') {
        newState = {
          ...state,
          soccerEvents: state.soccerEvents.map(soccerEvent => {
            return subscribeStateConstructor(soccerEvent, action.payload.eventId, true );
          })
        };
      } else if (action.payload.sportType === 'BASKETBALL') {
        newState = {
          ...state,
          basketballEvents: state.basketballEvents.map(basketballEvent => {
            return subscribeStateConstructor(basketballEvent, action.payload.eventId, true );
          })
        };
      }

      newState = {
        ...state,
        mobileLiveScoreFollowings: state.mobileLiveScoreFollowings.map(mobileLiveScoreFollowing => {
          return subscribeStateConstructor(mobileLiveScoreFollowing, action.payload.eventId, true );
        }),
        mobileLiveScoreCouponEvents: state.mobileLiveScoreCouponEvents.map(mobileLiveScoreCouponEvent => {
          return subscribeStateConstructor(mobileLiveScoreCouponEvent, action.payload.eventId, true );
        })
      };

      return newState;
    }


    case DELETE_SUBSCRIBE_EVENT_SUCCESS: {
      let newState;

      if (action.payload.sportType === 'SOCCER') {
        newState = {
          ...state,
          soccerEvents: state.soccerEvents.map(soccerEvent => {
            return subscribeStateConstructor(soccerEvent, action.payload.eventId, false );
          }),
        };
      } else if (action.payload.sportType === 'BASKETBALL') {
        newState = {
          ...state,
          basketballEvents: state.basketballEvents.map(basketballEvent => {
            return subscribeStateConstructor(basketballEvent, action.payload.eventId, false );
          })
        };
      }

      newState = {
        ...state,
        mobileLiveScoreFollowings: state.mobileLiveScoreFollowings.map(mobileLiveScoreFollowing => {
          return subscribeStateConstructor(mobileLiveScoreFollowing, action.payload.eventId, false );
        }),
        mobileLiveScoreCouponEvents: state.mobileLiveScoreCouponEvents.map(mobileLiveScoreCouponEvent => {
          return subscribeStateConstructor(mobileLiveScoreCouponEvent, action.payload.eventId, false );
        })
      };
      return newState;
    }

    case LIVE_SCORES_ACTIVE_TYPE:
      return { ...state, activeType: action.activeType };

    default:
      return state;
  }
};
